import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import * as BosFilesServices from "data/BosWebServices/BosFilesServices";
import * as Constants from "../logic/Constants";
import * as WidgetUtils from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./ActionWidget.module.scss";

export function ActionWidget(props) {
  const { ui, data, config, doAction, dataSegment } = props;
  const [buttonImage, setButtonImage] = useState("");
  const widgetId = ui.id;

  let disabledByUi = ui.readonly;
  let disabledByData = data && data.readonly;
  let disabledByContent = false;

  let textByLabel = ui.label ? ui.label : null;
  let textByConfig = config ? config.Text : null;
  let textByContent = null;

  let fileId = config ? config.ResourceId : null;

  let renderAsLink = config ? config.IsLinkButton === true : false;

  if (data && data.content) {
    let parts = data.content.split(Constants.INDEX_SEPARATOR);
    if (parts[0]) disabledByContent = parts[0] === "False";
    if (parts[1]) textByContent = parts[1];
  }

  let content = textByContent ? textByContent : textByConfig ? textByConfig : textByLabel ? textByLabel : null;
  let disabled = disabledByContent ? disabledByContent : disabledByData ? disabledByData : disabledByUi ? disabledByUi : false;

  useEffect(() => {
    //console.log("ActionWidget data of " + ui.id + ": ", data);
  }, [data]);

  useEffect(() => {
    if (fileId)
      setButtonImage(BosFilesServices.getProtectedWebResourceUrl(dataSegment.authToken, fileId));
    else
      setButtonImage();
  }, [fileId]);

  const buttonOnClick = async (actionId) => {
    doAction(actionId);
  };

  const linkButtonStyle = {
    lineHeight: ui.controlHeight + "em",
    width: "100%"
  };

  return renderAsLink
    ? (
      <Link
        className={cn(disabled ? classes.linkButtonDisabled : "")}
        style={linkButtonStyle}
        id={widgetId}
        to=""
        onClick={(e) => {
          e.preventDefault();
          buttonOnClick(config.ActionId)
        }}>
        {WidgetUtils.toCleanText(content)}
      </Link>
    ) : (
      <Button
        className={classes.button}
        id={widgetId}
        onClick={() => buttonOnClick(config.ActionId)}
        disabled={disabled}
        text={WidgetUtils.toCleanText(content)}
        icon={buttonImage}
        height={ui.controlHeight + "em"}
        width="100%"
      />
    );
}